import {
  Action,
  type AccessRequest,
  type Actor,
  type PreventiveMaintenanceResource,
  type ServiceRequestResource,
} from 'domains-work-order-authorization';

export interface AttachmentAccess {
  canRead: boolean;
  canCreate: boolean;
  canDelete: boolean;
}

type AttachmentResource =
  | ServiceRequestResource
  | PreventiveMaintenanceResource;

interface AttachmentAccessRequest<TResource extends AttachmentResource> {
  actor: Actor;
  resource: TResource;
  isEnforced: boolean;
  canAccess: (request: AccessRequest<TResource>) => boolean;
}

export const FULL_ATTACHMENT_ACCESS: AttachmentAccess = {
  canRead: true,
  canCreate: true,
  canDelete: true,
};

export const getAttachmentAccess = <TResource extends AttachmentResource>({
  actor,
  resource,
  isEnforced,
  canAccess,
}: AttachmentAccessRequest<TResource>): AttachmentAccess => {
  if (!isEnforced) return FULL_ATTACHMENT_ACCESS;

  const can = (action: Action) => canAccess({ actor, resource, action });

  return {
    canRead: can(Action.Read),
    canCreate: can(Action.Create),
    canDelete: can(Action.Delete),
  };
};
